








































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import Snackbar from './components/SnackBar.vue'
import { UserProfile } from './store/modules/views/userProfile/states'
import VueExtendedBaseComponent from './VueExtendedBaseComponent.vue'
import { UserStatus } from './services/userInterface'
import liff from '@line/liff'
import { ELevel } from './services/Menus'

@Component({
  components: {
    Snackbar,
  },
})
export default class SidebarViewModel extends VueExtendedBaseComponent {
  private drawer = this.$vuetify.breakpoint.lgAndUp
  private showAlert: boolean = false
  get toolbarMenu() {
    const result = [{
      name: 'ข้อมูลผู้ใช้งาน',
      icon: 'account-circle',
      action: this.navigateToProfilePage,
    }]
    if (this.profile.schedule) {
      result.push({
        name: 'งานวันนี้',
        icon: 'calendar-account',
        action: this.navigateToTodayPage,
      })
    }
    if (liff.getOS() === 'web') {
      result.push({
        name: 'ออกจากระบบ',
        icon: 'logout',
        action: this.handleLogout,
      })
    }
    return result
  }

  @Getter('components/snackBarLists')
  private snackbar!: []

  @Getter('components/titlePage')
  private titlePage!: ''

  @Getter('userprofile/getProfile')
  private profile!: UserProfile

  @Getter('components/pageLoading')
  private pageLoading!: boolean

  @Getter('components/ready')
  private ready!: boolean

  @Action('userprofile/getUserProfile')
  private getUserProfile!: (options: {}) => void

  @Action('register/sendVerifyEmail')
  private sendVerifyEmail!: () => { code: number; message: string }

  private handleLogout() {
    const level = localStorage.getItem('level')
    liff.logout()
    localStorage.clear()
    if (level) {
      localStorage.setItem('level', level)
    }
    this.$router.go(0)
  }

  private navigateToProfilePage() {
    this.$store.dispatch('components/setLevel', {id: this.profile._id, mode: ELevel.USER})
    this.$router.push(`/action/profile`)
  }

  private navigateToTodayPage() {
    this.$store.dispatch('components/setLevel', {id: this.profile._id, mode: ELevel.USER})
    localStorage.removeItem('scheduleView')
    this.$router.push(`/action/today`)
  }

  private async mounted() {
    this.pageStartLoading()
    // if (!this.profile.email && localStorage.getItem('token')) {
    //   await this.getUserProfile({})
    //   // this.showAlert = this.profile.status <= UserStatus.VERIFYEMAIL
    // }
    const version = localStorage.getItem('version')
    const newVersion = process.env.VUE_APP_VERSION
    if (newVersion && (!version || version !== newVersion)) {
      localStorage.setItem('version', newVersion)
      window.location.reload(true)
    }
    this.pageStopLoading()
  }
}
